import { Button, Grid } from '@mui/material';
import { useState } from 'react';
import { HOST_API_URL } from '../../../../config-global';
import Iconify from '../../../../reusable-components/iconify';
import GlAPIModal from './GlAPIModal';
import NewGLModal from './NewGlModal';
import { ConfirmDialog } from '../../../../reusable-components/confirm-dialog';


export default function CustomToolbar({
  isSelecting,
  setIsSelecting,
  selectedGLs,
  updateSelectedGLs,
  handleBulkDelete,
}) {
  const [isDeleting, setIsDeleting] = useState(false); 

  const onDelete = async () => {
    setIsDeleting(true);

    try {
      await handleBulkDelete();
    } finally {
      setIsDeleting(false);
    }
  };

  const memoConfirm = (
    <ConfirmDialog
      button="outlined"
      color="error"
      disabled={selectedGLs.length === 0 || isDeleting}
      title="Delete GL items"
      content={`Are you sure you want to delete ${selectedGLs.length} GL item${selectedGLs.length === 1 ? '' : 's'}?`}
      actionButton={isDeleting ? 'Deleting...' : 'Delete'}
      action={onDelete}
      manualLoading={isDeleting}
    />
  );

  return (
    <>
      <Grid container direction="row" justifyContent="flex-start" alignItems="center">
        <Grid item>
          <Grid container direction="row" alignItems="flex-end" spacing={1} sx={{ mb: 1 }}>
            {!isSelecting ? (
              <Grid item>
                <Button
                  size="small"
                  variant="contained"
                  color="secondary"
                  onClick={() => {
                    updateSelectedGLs([]);
                    setIsSelecting(true);
                  }}
                  startIcon={<Iconify icon="ph:check-fill" />}
                >
                  Delete GLs
                </Button>
              </Grid>
            ) : (
              <>
                <Grid item>{memoConfirm}</Grid>
                <Grid item>
                  <Button
                    size="small"
                    sx={{ textDecoration: 'underline' }}
                    color="secondary"
                    disabled={isDeleting}
                    onClick={() => {
                      updateSelectedGLs([]);
                      setIsSelecting(false);
                    }}
                  >
                    Cancel
                  </Button>
                </Grid>
              </>
            )}
            {!isSelecting && (
              <Grid item>
                <NewGLModal />
                <GlAPIModal />
                <Button
                  variant="outlined"
                  size="small"
                  color="secondary"
                  onClick={() => {
                    window.open(`${HOST_API_URL}Api/Invoices/DownloadInvoiceGLs`, '_blank');
                  }}
                  startIcon={<Iconify icon="file-icons:microsoft-excel" />}
                >
                  Download Invoice GLs
                </Button>
              </Grid>
            )}
          </Grid>
        </Grid>
      </Grid>
    </>
  );
}
